module.exports = __webpack_public_path__ + "img/abz-logo.af08d409.png";